import { appRoles } from "#src/constants/appRoles.js";
export class AuthPayload {
    id;
    fullname;
    username;
    designation;
    email;
    roles;
    Permissions;
    maxReportingLevel;
    get isAdmin() {
        return this.roles.includes(appRoles.Admin);
    }
    hasRole(role) {
        if (this.isAdmin) {
            return true;
        }
        return this.roles.includes(role);
    }
    hasAnyRole(roles) {
        if (this.isAdmin) {
            return true;
        }
        return this.roles.some((role) => roles.includes(role));
    }
    hasPermission(permission) {
        if (this.isAdmin) {
            return true;
        }
        return this.Permissions.includes(permission);
    }
    hasAnyPermission(permissions) {
        if (this.isAdmin) {
            return true;
        }
        return this.Permissions.some((p) => permissions.includes(p));
    }
    constructor(obj) {
        Object.assign(this, obj);
    }
    static create(obj) {
        return new AuthPayload(obj);
    }
}
//# sourceMappingURL=AuthPayload.js.map